import {Injectable} from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class LogicalConjunctionService {
  readonly defaultValue = 'N\\A';

  constructor() {
  }

  generateNoticeMessage(andItems = [], orItems = [], target = 'Source'): string {
    if (_.isEmpty(andItems) && _.isEmpty(orItems)) {
      return '';
    }

    if (!_.isEmpty(andItems) && _.isEmpty(orItems)) {
      return `If a ${andItems.join(' <b>and</b> a ')} ${(this.singularOrPlural(andItems))} matched, the '${target}' will be matched.`;
    } else if (_.isEmpty(andItems) && !_.isEmpty(orItems)) {
      return `If a ${orItems.join(' <b>or</b> a ')} is matched, the '${target}' will be matched.`;
    } else {
      return `If a ${andItems.join(' <b>and</b> a ')} ${(this.singularOrPlural(andItems))}
        matched <b>AND</b> a ${orItems.join(' <b>or</b> a ')} is matched, the '${target}' will be matched.`;
    }
  }

  generateAndDescription(items, propertyName): string {
    if (items.length === 1) {
      return `"${items[0][propertyName] || this.defaultValue}"`;
    }

    return items.slice(0, -1)
            .map(item => `"${item[propertyName] || this.defaultValue}"`).join(', ')
        + ` and "${items[items.length - 1][propertyName] || this.defaultValue}"`;
  }

  private singularOrPlural(items): string {
    return items.length === 1 ? 'is' : 'are';
  }
}
